export const checkStringRegExpMatch = (patternString: string, text: string) => {
  if (typeof patternString !== "string") return false;
  const matcher = new RegExp(patternString);
  return matcher.test(text);
};
